import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { CommitmentType } from 'further-types/lp/vehicle';
import api, { type ApiResponses } from 'lib/trpcClient';
import { UpdateCapitalActionFormValues } from '../hooks/useCapitalActionForm';

export default function useTotalCapitalContributionUsed({
  vehicleId,
  commitmentType,
  entries,
}: {
  vehicleId: string;
  commitmentType: CommitmentType | undefined;
  entries: UpdateCapitalActionFormValues['entries'];
}) {
  const isCapitalAndLoan = commitmentType === CommitmentType.CapitalAndLoan;

  const getTotalCapitalContributionUsed =
    api.capitalAction.getTotalCapitalContributionUsed.useMutation();

  const result = useQuery<
    ApiResponses['capitalAction']['getTotalCapitalContributionUsed']
  >({
    queryKey: [
      'totalCapitalContributionUsed',
      { params: { vehicleId, entries } },
    ],
    queryFn: async () => {
      return getTotalCapitalContributionUsed.mutateAsync({
        vehicleId,
        entries: entries ?? [],
      });
    },
    enabled: isCapitalAndLoan && !!vehicleId,
    placeholderData: keepPreviousData,
    gcTime: 0,
  });

  return { total: result.data ?? 0, isLoading: result.isFetching };
}
